const getAllowedOrigins = () => {
	const current = document.location.origin;
	const pattern = /((.uk.)|(.us.)|(.hk.))/;
	return [
		current.replace(pattern, '.hk.'),
		current.replace(pattern, '.uk.'),
		current.replace(pattern, '.us.')
	];
};

// called by child iframe
const safeMessageParent = ({ message, data }) => {
	try {
		getAllowedOrigins().forEach(origin => {
			window.parent.postMessage(
				{
					message: message,
					data: data
				},
				{ targetOrigin: origin }
			);
		});
	} catch (e) {
		console.error(e);
	}
};

export const emitRegionChange = ({ region }) => {
	const WINDOW_REGION_CHANGE = { message: 'ev-region-change', version: 1 };
	safeMessageParent({
		message: WINDOW_REGION_CHANGE.message,
		data: { ...WINDOW_REGION_CHANGE, region }
	});
};
